import { JobcaseEnablement } from 'lib/types/newspaperOrder';
import { OrderRate } from 'lib/types/rates';

export function getJobcaseEnablement(rate: OrderRate): JobcaseEnablement {
  return {
    upsellDescription: rate.jobcaseFee?.upsellDescription,
    showJobcase: rate.jobcaseFee?.enabled ?? false
  };
}
